module.exports = __webpack_public_path__ + "static/media/investment.96625f5b.svg";